import React from 'react';
export interface BadgeProps {
  variant?: 'success' | 'warning' | 'error' | 'info' | 'default';
  children: React.ReactNode;
  'data-id'?: string;
}
export const Badge: React.FC<BadgeProps> = ({
  variant = 'default',
  children,
  'data-id': dataId
}) => {
  const variantStyles = {
    success: 'bg-[#10B981]/15 text-[#10B981]',
    warning: 'bg-[#F59E0B]/15 text-[#F59E0B]',
    error: 'bg-[#EF4444]/15 text-[#EF4444]',
    info: 'bg-[#3B82F6]/15 text-[#3B82F6]',
    default: 'bg-[#475569]/15 text-[#475569]'
  };
  return <span className={`inline-flex items-center rounded-md px-2.5 py-1 text-xs font-medium ${variantStyles[variant]}`} data-id="element-5542" data-mp="2kq16tb80atio">
      {children}
    </span>;
};